import { IntegrationBusFactory } from "@/Common/Modularity/IntegrationBus/IntegrationBusFactory";

/** Payload for when a medical documents search is about to be executed. */
type MedicalDocumentsSearchRequestedPayload = Record<string, never>;

/** Event triggered right before dispatching the `Myle_MedicalDocuments_Search` operation. */
const MedicalDocumentsSearchRequestedEvent = IntegrationBusFactory.createEvent<MedicalDocumentsSearchRequestedPayload>("MedicalDocumentsSearchRequestedEvent");

export {
    MedicalDocumentsSearchRequestedEvent,
    MedicalDocumentsSearchRequestedPayload
};
